import React, { Dispatch, useContext, useState } from 'react';
import { Typography, Button } from '@material-ui/core';
import Radiogroup from '../portico/radiogroup/radiogroup';
import STATIC_TEXT from '../../content/common.json';
import PublicWrapper from '../public-wrapper/public-wrapper';
import useSelectEntityStyles from './select-entity.styles';
import { fetchEntityAndJourneyData, fetchEntityInfo, fetchJourneyInfo, fetchUserNextSteps } from '../../utils/fenergo-utils';
import BANNER_IMG_URL_RECTANGLE from '../../assets/Rectangle_122.png';
import WELCOME_IMG from '../../assets/welcome_image.svg';
import { Navigate, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEntityState } from '../../stores/entity/entity.hooks';
import { JourneyWrapper } from '../journey-wrapper';
import { LoginContentModel } from '../../interfaces/LoginContent.interface';
import useLoginStyles from '../login/login.styles';
import { FeatureToggleContext } from '../../config/toggle.context';

export const SelectEntity: React.FC = () => {
  const classes = useSelectEntityStyles();
  const navigate = useNavigate();
  const classes1 = useLoginStyles();
  const dispatch: Dispatch<any> = useDispatch();
  const { entities, selectedEntity, initialJourneyTasks, selectedJourneyTask, journeyTasksLoadInProgress } = useEntityState();
  const [selectedEntityId, setSelectedEntityId] = useState('');
  const loginContent: LoginContentModel = STATIC_TEXT.login
  const { useToggle } = useContext(FeatureToggleContext);
  const toggleReadableUrl = useToggle("ftReadableUrlPaths");

  const onNext = () => {
    const entity = entities.find(entity => fetchEntityInfo(entity).id === selectedEntityId);
    // fetchEntityAndJourneyData(dispatch, entity, journeyTasksLoadInProgress);
    fetchEntityAndJourneyData(dispatch, navigate, entity, journeyTasksLoadInProgress, fetchJourneyInfo(entity).journeyId, toggleReadableUrl(false, true));
    navigate('/');
  };

 return (
    <JourneyWrapper>
      {
        ((entities.length > 1 && !selectedEntity)) ?
          <PublicWrapper
            title="Welcome Back!"
            bannerImgUrlRectangle={BANNER_IMG_URL_RECTANGLE}
            bannerImgUrlWomanWorkingOnlaptop={WELCOME_IMG}
            displaySecondaryOnMobile
            children={(
              <div>
                <Typography variant="h1" className={classes.subtitle}>
                {loginContent.subTitle.map((element, index) => <ul key={index} className={classes1.noListMargin}>{element}</ul>)}
                </Typography>
                <Typography variant="body1" className={classes.subtitle}>
                  {STATIC_TEXT.welcome.selectEntity.title}
                </Typography>
                <div className={classes.content}>
                  <Radiogroup
                    uiRenderOptions={{row: false}}
                    label="Entities"
                    name='entity'
                    items={entities.map(entity => ({ label: entity.company.properties.legalEntityName?.value, value: fetchEntityInfo(entity).id }))}
                    value=""
                    onChange={(event, value) => setSelectedEntityId(value)}
                    data-testid="entityName"
                    data-cy='select-prospect'
                  />
                  <Button
                    className={classes.continueBtn}
                    onClick={onNext}
                    disabled={!selectedEntityId}
                    data-testid="selectEntity"
                    data-cy='select-prospect-btn'
                  >
                    {STATIC_TEXT.welcome.navigationButton.letsGo}
                  </Button>
                </div>
              </div>
            )}
          /> :
          (entities.length === 1 && initialJourneyTasks && selectedJourneyTask && (
            <Navigate to={fetchUserNextSteps(fetchEntityInfo(entities[0]), initialJourneyTasks, selectedJourneyTask, toggleReadableUrl(false, true))} />
          ))
      }
    </JourneyWrapper>
  );
};
